export function resolveEnvelopeEndpoint(
  envelopeId: string,
  template: string
): string {
  const path = template
    .replace("{envelopeId}", encodeURIComponent(envelopeId))
    .replace("{envelope_id}", encodeURIComponent(envelopeId));

  return path.startsWith("/") ? path : `/${path}`;
}
